import axios from 'axios';

export default class WorkReportService {
  async getIncomes(projectId) {
    const response = await axios({
      method: 'get',
      url: `projects/${projectId}/categories/2/items`,
      withCredentials: true,
    }).catch((error) => {
      console.log('Work reports: getIncomes', error);
      throw error;
    });

    return response.data;
  }

  async getIncomesWithEmployees(projectId) {
    const response = await axios({
      method: 'get',
      url: `projects/${projectId}/categories/2/items/with-employees`,
      withCredentials: true,
    }).catch((error) => {
      console.log('Work reports: getIncomesWithEmployees', error);
      throw error;
    });

    return response.data;
  }

  async getWorkReport(projectId, { dateinfo, employee_id, item_id }) {
    const data = { dateinfo, employee_id, item_id };

    const response = await axios({
      method: 'post',
      url: `projects/${projectId}/workReports/get-one`,
      withCredentials: true,
      data,
    }).catch((error) => {
      console.log('Work reports: getWorkReport', error);
      throw error;
    });

    return response.data;
  }

  async getWorkReports(
    projectId,
    fromDate,
    toDate,
    employeeIds,
    itemIds,
    hasInvoice,
    page,
    itemsPerPage,
  ) {
    const data = {
      fromDate,
      toDate,
      employeeIds,
      itemIds,
      hasInvoice,
      pagination: {
        page,
        itemsPerPage,
      },
    };

    const response = await axios({
      method: 'post',
      url: `projects/${projectId}/workReports/get`,
      withCredentials: true,
      data,
    }).catch((error) => {
      console.log('Work reports: getWorkReports', error);
      throw error;
    });

    return response.data;
  }

  async updateWorkReport(
    projectId,
    { id, dateinfo, employee_id, item_id, has_invoice, report_note, fact_minutes },
    force = false,
  ) {
    // NOTE! hours are used in FE now (not minutes - to be used later)
    const data = {
      id,
      dateinfo,
      employee_id,
      item_id,
      has_invoice: !!has_invoice,
      report_note,
      fact_minutes,
      force,
    };

    try {
      const response = await axios({
        method: 'post',
        url: `projects/${projectId}/workReports/update`,
        withCredentials: true,
        data,
      });
      return {
        updatedId: response.data,
      };
    } catch (error) {
      if (error && error.response && error.response.status === 409) {
        return {
          conflictId: error.response.data,
        };
      }
      console.log('Work reports: updateWorkReport', error);
      throw error;
    }
  }

  async deleteWorkReport(projectId, { dateinfo, employee_id, item_id }) {
    const data = { dateinfo, employee_id, item_id };

    const response = await axios({
      method: 'post',
      url: `projects/${projectId}/workReports/delete`,
      withCredentials: true,
      data,
    }).catch((error) => {
      console.log('Work reports: deleteWorkReport', error);
      throw error;
    });

    return response.data;
  }

  async assignEmployeeToProject(projectId, incomeItemId, employeeId) {
    await axios({
      method: 'post',
      url: `projects/${projectId}/timesheet/data/assign-employee`,
      withCredentials: true,
      data: {
        employeeId,
        incomeItemId,
      },
    }).catch((error) => {
      console.log('Work reports: assignEmployeeToProject', error);
      throw error;
    });
  }
}
